import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getStaffMailCount } from '../../services/api';

const POLL_MS = 60 * 1000;

function StaffMailButton() {
    const location = useLocation();
    const [counts, setCounts] = useState({ open: 0, unseen: 0 });

    const load = useCallback(() => {
        getStaffMailCount()
            .then(res => { if (res?.success) setCounts({ open: res.open || 0, unseen: res.unseen || 0 }); })
            .catch(() => {});
    }, []);

    useEffect(() => {
        load();
        const timer = setInterval(load, POLL_MS);
        return () => clearInterval(timer);
    }, [load]);

    useEffect(() => { load(); }, [location.pathname, load]);

    const isActive = location.pathname.startsWith('/staff/mailbox');
    const icon = counts.unseen > 0 ? 'mail_2.gif' : 'mail_1.gif';

    return (
        <Link
            to="/staff/mailbox"
            title={`${counts.open} open, ${counts.unseen} nobody has opened yet`}
            className={`ml-auto flex items-center gap-2 px-3 py-2 font-['Jersey_10'] text-[19px] uppercase leading-none tracking-[1px] transition-colors
                ${isActive ? 'bg-black/35 text-gold' : 'text-white hover:bg-black/20'}`}
            style={{ textShadow: '1px 1px 0 rgba(0,0,0,0.5)' }}
        >
            <span className="hidden sm:inline">Mailbox</span>

            <span className="relative flex items-center">
                <img src={`${process.env.PUBLIC_URL}/img/${icon}`} alt="Staff mailbox" />
                {counts.open > 0 && (
                    <span
                        className="absolute -right-2 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white"
                        style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.5)' }}
                    >
                        {counts.open > 9 ? '9+' : counts.open}
                    </span>
                )}
            </span>
        </Link>
    );
}

export default StaffMailButton;
